// extracted by mini-css-extract-plugin
module.exports = {"item":"style__item__K98Ti","question":"style__question__MbUm1","q":"style__q__XkA9g","answer":"style__answer__ggKhG","a":"style__a__zmv7a","controls":"style__controls__QJe2s"};